module.exports = __webpack_public_path__ + "static/media/iconfinder_next_black_308956.c27fae8b.svg";